import { useParams, useNavigate } from 'react-router-dom';
import appConfig from '../config/app-config';

const { address, key } = appConfig.apis.legalApiEnv;

export const useCreditOperation = () => {
    const navigate = useNavigate();

    const {
        page = '0',
        pageSize = '200',
        field: fieldSorted = 'contract_number',
        order: orderSorted = 'ASC',
        filter,
    } = useParams();

    let searchTerm = '';
    let contractTypeFilter = '';
    if (filter) {
        const searchMatch = filter.match(/s=(.*?);/);
        if (searchMatch) searchTerm = searchMatch[1];
        const typeMatch = filter.match(/t=(.*?);/);
        if (typeMatch) contractTypeFilter = typeMatch[1];
    }

    const buildFilter = (search: string, contractType: string) => {
        let f = '';
        if (search) f += `s=${search};`;
        if (contractType) f += `t=${contractType};`;
        return f || undefined;
    };

    const basePath = '/legal/credit-operations';
    const buildUrl = (p: string, ps: string, f: string, o: string, fl?: string) =>
        fl ? `${basePath}/${p}/${ps}/${f}/${o}/${fl}` : `${basePath}/${p}/${ps}/${f}/${o}`;

    const contractTypeParam = contractTypeFilter ? `&contractType=${encodeURIComponent(contractTypeFilter)}` : '';
    const url = `${address}/credit-operations/page-list?page=${page}&size=${pageSize}&search=${encodeURIComponent(searchTerm)}&sort=${fieldSorted},${orderSorted}${contractTypeParam}`;

    const pageChanged = (p: number) => navigate(buildUrl(String(p), pageSize, fieldSorted, orderSorted, buildFilter(searchTerm, contractTypeFilter)));
    const pageSizeChanged = (ps: number) => navigate(buildUrl('0', String(ps), fieldSorted, orderSorted, buildFilter(searchTerm, contractTypeFilter)));
    const pageSorted = (field: string, order: 'ASC' | 'DESC') => navigate(buildUrl(page, pageSize, field, order, buildFilter(searchTerm, contractTypeFilter)));
    const searchChanged = (search: string) => navigate(buildUrl('0', pageSize, fieldSorted, orderSorted, buildFilter(search, contractTypeFilter)));
    const contractTypeChanged = (value: string) => navigate(buildUrl('0', pageSize, fieldSorted, orderSorted, buildFilter(searchTerm, value)));
    const onFilterClean = () => navigate(buildUrl('0', pageSize, fieldSorted, orderSorted));

    return {
        page, pageSize, fieldSorted, orderSorted, searchTerm,
        contractTypeFilter,
        url, API_KEY: key, API_ADDRESS: address,
        pageChanged, pageSizeChanged, pageSorted,
        searchChanged, contractTypeChanged, onFilterClean,
    };
};
